import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Blog = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
          {t('common.blog')}
        </h1>
        <p className="text-xl text-gray-400 mb-8">
          {t('blog.comingSoon', 'Coming Soon')}
        </p>
        <p className="text-lg text-gray-500 mb-12">
          {t('blog.description', 'Stay tuned for articles about fitness, nutrition, and wellness.')}
        </p>
        
        <Link 
          to="/"
          className="inline-flex items-center text-secondary hover:text-green-400 transition-colors duration-300 font-medium"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          {t('blog.backToHome', 'Back to Home')}
        </Link>
      </div>
    </div>
  );
};

export default Blog;
